import { defineStore } from 'pinia'
import { EaseChatClient } from '@/IM/initwebsdk'
import tool from '@/utils/tool'
import imuserApi from '@/api/onlineChat/imuserApi'
import { useImMessageStore  } from '@/store'

let _imOpenPromise = null
// open 成功后 30 分钟内认为登录还"新鲜"，超过就重新验证一次
const MAX_OPEN_AGE_MS = 30 * 60 * 1000

export const useImInfoStore = defineStore({
    id: 'imInfo',
    state: () => ({
        imInfo: tool.session.get('IM_INFO') || {},
        // 环信 SDK 真实连接状态，由 onConnected / onDisconnected 事件更新
        connected: false,
        // 最近一次 open 成功的时间戳
        lastOpenAt: 0,
    }),
    actions: {
        updateConnected(val) {
            this.connected = !!val
        },
        async getImInfo({ forceRefresh = false } = {}) {
            if (!tool.session.get('USER_INFO')) return null
            const isUserType1 = String(tool.data.get('currentUserType')) === '1'

            const info = this.imInfo || {}
            const usernameOk = !!(info.userResource && info.userResource.username)
            const userMatch = !!(EaseChatClient.user && usernameOk && info.userResource.username === EaseChatClient.user)
            const tokenOk = !!info.accessToken
            const fresh = (Date.now() - (this.lastOpenAt || 0)) <= MAX_OPEN_AGE_MS
            // 必须四者都满足才跳过 open：用户名匹配 + token 存在 + 连接事件确认连上 + 30 分钟内
            const sdkReady = userMatch && tokenOk && this.connected && fresh

            if (sdkReady && !forceRefresh) {
                return info
            }

            // forceRefresh 不走单例锁，确保一定会清缓存并重新登录（避开旧死连接复用再次 39）
            if (!forceRefresh && _imOpenPromise) return _imOpenPromise

            const run = async () => {
                try {
                    if (forceRefresh) {
                        try { tool.session.remove('IM_INFO') } catch (_) {}
                        this.imInfo = {}
                        this.connected = false
                        try { EaseChatClient.close() } catch (_) {}
                    }
                    const res = isUserType1
                        ? await imuserApi.imUserDetailOnLogin()
                        : await imuserApi.imCompanyDetail()
                    this.imInfo = res || {}
                    tool.session.set('IM_INFO', this.imInfo)
                    if (this.imInfo && this.imInfo.accessToken && this.imInfo.userResource && this.imInfo.userResource.username) {
                        await EaseChatClient.open({
                            user: this.imInfo.userResource.username,
                            accessToken: this.imInfo.accessToken,
                        })
                        this.lastOpenAt = Date.now()
                    }
                    return this.imInfo
                } finally {
                    _imOpenPromise = null
                }
            }
            _imOpenPromise = run()
            return _imOpenPromise
        },
        imLogout() {
            _imOpenPromise = null
            this.connected = false
            this.lastOpenAt = 0
            try { EaseChatClient.close() } catch (_) {}
            const obj = { currentChat: { lastMessage: {} } }
            useImMessageStore().updateCurrentChat(obj)
        },
    },
})
